import { css } from '@emotion/react';
import Page from 'components/Page/Page';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function NoProjectsScreen() {
  return (
    <Page>
      <Grid
        container
        direction="row"
        sx={{ justifyContent: 'center', alignItems: 'center' }}
        css={css`
          flex-grow: 1;
        `}
      >
        <Paper
          elevation={2}
          css={css`
            text-align: center;
            padding: 2rem;
          `}
        >
          <Typography component="h1" variant="h3">
            Projects
          </Typography>
          <Alert
            severity="warning"
            css={css`
              margin-top: 32px;
            `}
          >
            You don&apos;t have any projects yet. Please contact an administrator.
          </Alert>
        </Paper>
      </Grid>
    </Page>
  );
}
